"use client";

import React from "react";
import {  Form, } from "react-bootstrap";
import style from "@/components/Products/cateogry.module.scss";
import { PriceIntervals } from "@/common/entities/product/Attributes";

interface SingleAttributeSideFilterProps {
    onPriceIntervalFilter: (min: number, max: number) => void;
    filters: { [key: string]: string | undefined };
    priceIntervals?: PriceIntervals[];
}

const PriceIntervalsFilter = ({
                                  onPriceIntervalFilter,
                                  filters,
                                  priceIntervals,
                              }: SingleAttributeSideFilterProps) => {
    const currentMin = parseInt(filters.minPrice || "", 10);
    const currentMax = parseInt(filters.maxPrice || "", 10);

    const hasSelected = !isNaN(currentMin) && !isNaN(currentMax);

    const isRangeChecked = (min: number, max: number) =>
        currentMin === min && currentMax === max;

    const visibleIntervals = hasSelected
        ? priceIntervals?.filter(
            (interval) => interval.min === currentMin && interval.max === currentMax
        )
        : priceIntervals;

    return (
        <>
            {visibleIntervals && visibleIntervals.length > 0 &&
                <div className={style.cardFilter}>
                    <h5 className={style.cardTitle}>Pret</h5>
                    {visibleIntervals?.map(({ min, max }) => {
                        const isChecked = isRangeChecked(min, max);

                        return (
                            <div
                                className="d-flex justify-content-between align-items-center"
                                key={`${min}-${max}`}
                            >
                                <Form.Check
                                    type="radio"
                                    name="price-range"
                                    label={`${min} - ${max} lei`}
                                    id={`price-${min}-${max}`}
                                    checked={isChecked}
                                    onChange={() => onPriceIntervalFilter(min, max)}
                                />
                            </div>
                        );
                    })}
                </div>
            }
        </>
    );
};

export default PriceIntervalsFilter;